import { SvgProps } from "../../utils/types";

export default function ProfileDeleteIcon({ fill }: SvgProps) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.6192 14.8162C10.4198 14.8162 10.2205 14.7427 10.0631 14.5853C9.75876 14.281 9.75876 13.7773 10.0631 13.473L13.0222 10.5139C13.3265 10.2096 13.8302 10.2096 14.1345 10.5139C14.4388 10.8182 14.4388 11.3219 14.1345 11.6262L11.1754 14.5853C11.018 14.7427 10.8186 14.8162 10.6192 14.8162Z"
                fill={fill || "white"}
            />
            <path
                d="M13.5784 14.8162C13.379 14.8162 13.1796 14.7427 13.0222 14.5853L10.0631 11.6262C9.75876 11.3219 9.75876 10.8182 10.0631 10.5139C10.3674 10.2096 10.8711 10.2096 11.1754 10.5139L14.1345 13.473C14.4388 13.7773 14.4388 14.281 14.1345 14.5853C13.9771 14.7427 13.7778 14.8162 13.5784 14.8162Z"
                fill={fill || "white"}
            />
            <path
                d="M8.10658 7.74659C8.08658 7.74659 8.07325 7.74659 8.05325 7.74659C8.01992 7.73992 7.97325 7.73992 7.93325 7.74659C5.99992 7.68659 4.53992 6.16659 4.53992 4.29325C4.53992 2.38659 6.09325 0.833252 7.99992 0.833252C9.90658 0.833252 11.4599 2.38659 11.4599 4.29325C11.4533 6.16659 9.98658 7.68659 8.12658 7.74659C8.11992 7.74659 8.11325 7.74659 8.10658 7.74659ZM7.99992 1.83325C6.64658 1.83325 5.53992 2.93992 5.53992 4.29325C5.53992 5.62659 6.57992 6.69992 7.90658 6.74659C7.94658 6.73992 8.03325 6.73992 8.11992 6.74659C9.42658 6.68659 10.4532 5.61325 10.4599 4.29325C10.4599 2.93992 9.35325 1.83325 7.99992 1.83325Z"
                fill={fill || "white"}
            />
            <path
                d="M7.99999 15.04C6.63999 15.04 5.35332 14.6866 4.37999 14.0333C3.45332 13.4133 2.94666 12.5666 2.94666 11.6533C2.94666 10.74 3.45999 9.89995 4.37999 9.28662C6.37332 7.95329 9.61332 7.95329 11.6067 9.28662C11.8333 9.43995 11.9 9.75329 11.7467 9.97995C11.5933 10.2133 11.28 10.2733 11.0533 10.12C9.39332 9.01329 6.59332 9.01329 4.93332 10.12C4.29332 10.5466 3.94666 11.0866 3.94666 11.6533C3.94666 12.22 4.29999 12.7733 4.93332 13.2C5.73999 13.74 6.82666 14.0333 7.99332 14.0333C8.26665 14.0333 8.49332 14.26 8.49332 14.5333C8.49332 14.8066 8.27332 15.04 7.99999 15.04Z"
                fill={fill || "white"}
            />
        </svg>
    );
}
